import { render, staticRenderFns } from "./DocumentsAttachmentTemplateComponent.vue?vue&type=template&id=03eb95b4&scoped=true&lang=pug"
import script from "./DocumentsAttachmentTemplateComponent.vue?vue&type=script&lang=ts"
export * from "./DocumentsAttachmentTemplateComponent.vue?vue&type=script&lang=ts"
import style0 from "./DocumentsAttachmentTemplateComponent.vue?vue&type=style&index=0&id=03eb95b4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03eb95b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03eb95b4')) {
      api.createRecord('03eb95b4', component.options)
    } else {
      api.reload('03eb95b4', component.options)
    }
    module.hot.accept("./DocumentsAttachmentTemplateComponent.vue?vue&type=template&id=03eb95b4&scoped=true&lang=pug", function () {
      api.rerender('03eb95b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grids/ColumnTemplates/DocumentsAttachmentTemplateComponent.vue"
export default component.exports